/*
 *Page feature intro
 */

import { EBadgeLabel } from "@/models/setting.model";

export interface IPageFeatureIntroModalOptions {
  header?: string;
  cancelBtnText?: string;
  confirmBtnText: string;
}

/*
 *App wide feature intro
 */

export interface IAppWideFeatureIntroItem {
  svgName: string;
  title: string;
  description: string;
  objective?: string;
  additionalInfo?: string[];
  stageBadge?: EBadgeLabel;
}

export const featureIntroItems: IAppWideFeatureIntroItem[] = [
  {
    svgName: "feature-intro-1",
    title: "Flexible workload submission",
    description: "Submit your workloads with the new customizable form",
    objective:
      "Choose from an existing setup and customize as needed, or fill in your own settings. Review existing setups and understand policy definitions.",
    additionalInfo: ["From cluster v2.18 onward"],
    stageBadge: EBadgeLabel.Experimental,
  },
  {
    svgName: "feature-intro-2",
    title: "Data volumes in the UI",
    description: "Share data across different scopes in a cluster, including projects and departments",
    objective: "Use a single copy of data to ensure efficiency, maintain consistency and enhance collaboration.",
    additionalInfo: ["From cluster v2.19 onward"],
    stageBadge: EBadgeLabel.Experimental,
  },
  {
    svgName: "feature-intro-3",
    title: "Roll updates for Inference workloads",
    description: "Roll updates via UI",
    objective:
      "Update the configuration of live inference workloads and deploy new model versions without disrupting services for customers.",
    additionalInfo: ["From cluster v2.19 onward"],
  },
  {
    svgName: "feature-intro-4",
    title: "Enhancements to the Overview dashboard",
    description: "Optimization insights for your projects and departments",
    objective:
      "Offers department and project managers real-time visibility into GPU resource allocation and utilization, enabling more informed quota management decisions.",
  },
];

export const CURRENT_INTRO_VERSION = "v2.21";
